import { useRecoilTransaction_UNSTABLE } from 'recoil';

import { filterAtoms } from 'store/search/filter';

export const useClearAllFilters = (): (() => void) =>
  useRecoilTransaction_UNSTABLE(({ reset }) => () => {
    Object.values(filterAtoms).forEach((atom) => reset(atom));
  });
